import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-track-refund',
  templateUrl: './track-refund.component.html',
  styleUrls: ['./track-refund.component.css']
})
export class TrackRefundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
